export default __webpack_public_path__ + "static/media/02.06afb5f2.jpg";